import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import Payroll from "../pages/Payroll";
import { getKey } from "../helpers/sessionKey";
//@ts-ignore
import { WelcomeRouterService } from "@careinfo/welcome-page-service";

export const queryClient = new QueryClient();

const Router = () => {
  const shouldShowWelcome = getKey("shouldShowWelcome");
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path={"/payroll"}
            element={
              shouldShowWelcome === "true" || shouldShowWelcome === null ? (
                <WelcomeRouterService />
              ) : (
                <Payroll />
              )
            }
          />
          <Route path={"/payroll/overview"} element={<Payroll />} />
        </Routes>
      </HashRouter>
    </QueryClientProvider>
  );
};

export default Router;
